import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import FormFeedback from './FormFeedback';
import './FormInput.css';

function getId(id, name) {
  return id ? id : `form-input--${name}`;
}

const FormInput = forwardRef(
  (
    {
      id,
      name,
      type,
      initialValue,
      validate,
      maxLength,
      labelRenderer,
      disabled,
      givenRef,
      measurement,
      step,
      formatOnBlur,
      format,
      hidden,
      children,
      onClick
    },
    ref
  ) => {
    const formId = getId(id, name);
    let inputRef = null;

    if (!givenRef) {
      inputRef = useRef();
    } else {
      inputRef = givenRef;
    }

    const onFocus = () => {
      if (inputRef && inputRef.current) {
        inputRef.current.select();
      }
    }

    return (
      <label
        htmlFor={formId}
        className={classNames('form-input', {
          'form-input--disabled': disabled,
          'form-input--hidden': hidden
        })}
      >
        {typeof labelRenderer === 'function' && labelRenderer()}
        <Field
          name={name}
          type={type}
          initialValue={initialValue || null}
          validate={validate}
          format={format}
          formatOnBlur={formatOnBlur}
        >
          {({ input, meta }) => (
            <div className={measurement ? 'measurement' : null}>
              <input
                value={input.value || ''}
                name={name}
                onChange={input.onChange}
                className={!hidden && 'form-input__control'}
                type={input.type}
                ref={inputRef}
                maxLength={maxLength}
                step={step}
                onClick={onClick}
                onFocus={onFocus}
                onBlur={input.onBlur}
                disabled={disabled}
                id={formId}
                size={measurement ? maxLength : null}
              />
              {children && (
                <span>{children}</span>
              )}
              {measurement && (
                <span>{measurement}</span>
              )}
              {meta.submitError && !meta.modifiedSinceLastSubmit && (
                <FormFeedback positive={false}>
                  {meta.submitError}
                </FormFeedback>
              )}
              {meta.error && meta.dirty && (
                <FormFeedback positive={false}>
                  {meta.error}
                </FormFeedback>
              )}
            </div>
          )}
        </Field>
      </label>
    )
  })

FormInput.propTypes = {
  accept: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node
  ]),
  id: PropTypes.string,
  labelRenderer: PropTypes.func,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  reject: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['email', 'password', 'text', 'date', 'time', 'number'])
};

FormInput.defaultProps = {
  id: '',
  required: false,
  type: 'text',
  placeholder: '',
  disabled: false,
  accept: false,
  reject: false,
  labelRenderer: undefined,
  icon: undefined
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/form/FormInput.js